module.exports = __webpack_public_path__ + "img/home-educacao.4167f379.svg";